export const ageMethod = "age nearest";
export const gateway = "https://qat-mcdougall-shopper-api.link-nonprod.wawanesalife.com";
export const assets = "https://qat-assets.link-nonprod.wawanesalife.com/brokers/mcdougall";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJtY2RvdWdhbGwiLCJuYW1lIjoibWNkb3VnYWxsIiwiaWF0IjoxNzgwNTgwMjYyLCJleHAiOjE5MzgzNjgyNjJ9.-FNK6GTJcLQre7Ti51JJ9oyuAsIATzNkDQKraw8kvRk";
export const brokerConfig = {
	enabled: "yes",
	"split": '0.6'
};
export const brokerBranding = {
	"qat-mcdougall-shopper.link-nonprod.wawanesalife.com": {
		a: {
			approve_company: "Link Platform",
			approve_user: "link_mcdougall",
			brands: [
				"qat-mcdougall-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "mcdougall",
			broker_formatted_name: "McDougall Insurance",
			email: "belleville@mcdougallinsurance.com",
			environment: "qat",
			environment_id: "qat",
			g4: "GTM-KQT2NH5",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "(800) 361-0941",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
				"photo5.jpg",
				"photo6.jpg",
				"photo7.jpg",
				"photo8.jpg",
				"photo9.jpg",
			],
			privacyLink: "https://www.mcdougallinsurance.com/privacy-policy/",
			themeSwitcher: "show",
			website: "https://www.mcdougallinsurance.com/",
			scope: "mcdougall#branding#qat-mcdougall-shopper.link-nonprod.wawanesalife.com#a",
			ab: "a",
			logo: "a.png",
			brand_name: "qat-mcdougall-shopper.link-nonprod.wawanesalife.com",
		},
		b: {
			approve_company: "Link Platform",
			approve_user: "link_mcdougall",
			brands: [
				"qat-mcdougall-shopper.link-nonprod.wawanesalife.com",
			],
			broker: "mcdougall",
			broker_formatted_name: "McDougall Insurance",
			email: "belleville@mcdougallinsurance.com",
			environment: "qat",
			environment_id: "qat",
			g4: "GTM-KQT2NH5",
			layout: "modern",
			logoPosition: "menu",
			menuPhone: "button",
			phone: "(800) 361-0941",
			photos: [
				"photo1.jpg",
				"photo2.jpg",
				"photo3.jpg",
				"photo4.jpg",
				"photo5.jpg",
				"photo6.jpg",
				"photo7.jpg",
				"photo8.jpg",
				"photo9.jpg",
			],
			privacyLink: "https://www.mcdougallinsurance.com/privacy-policy/",
			themeSwitcher: "show",
			website: "https://www.mcdougallinsurance.com/",
			scope: "mcdougall#branding#qat-mcdougall-shopper.link-nonprod.wawanesalife.com#b",
			ab: "b",
			logo: "b.png",
			brand_name: "qat-mcdougall-shopper.link-nonprod.wawanesalife.com",
		},
	},
};

//updated on Thu Jun 04 2026 13:37:42 GMT+0000 (Coordinated Universal Time)
